import React from 'react';
import { useNavigate } from 'react-router-dom';

const ErrorPage = ({ title = 'Something went wrong', message = 'An unexpected error occurred. Please try again.', onRetry }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-dark flex flex-col items-center justify-center px-6 text-center">
      <div className="w-20 h-20 rounded-full bg-red-900/30 flex items-center justify-center mb-6">
        <svg className="w-10 h-10 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
      </div>
      <h1 className="text-xl font-bold text-light mb-2">{title}</h1>
      <p className="text-sm text-gray-400 mb-8 max-w-sm">{message}</p>
      <div className="flex gap-3">
        {onRetry && (
          <button onClick={onRetry}
            className="bg-gold text-dark px-6 py-2.5 rounded-lg font-semibold">
            Try Again
          </button>
        )}
        <button onClick={() => navigate(-1)}
          className="bg-gray-800 text-light px-6 py-2.5 rounded-lg font-semibold border border-gray-700">
          Go Back
        </button>
        <button onClick={() => navigate('/')}
          className="bg-gray-800 text-light px-6 py-2.5 rounded-lg font-semibold border border-gray-700">
          Home
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
